// extracted by css-extract-rspack-plugin
export default {"Box_0":"VisibleAndOverflowContainer-module__Box_0__F0WgscF","space":"VisibleAndOverflowContainer-module__space__iXiJY7s"};